import _ from 'lodash'
import moment from 'moment'

// Order matters: for ambiguous values like 01/02/2026 moment picks the first
// matching format, so month-first (the template format) wins over day-first.
const BASE_FORMATS = [
  'YYYY-M-D',
  'YYYY/M/D',
  'YYYY.M.D',
  'YYYYMMDD',
  'M/D/YYYY',
  'M-D-YYYY',
  'M.D.YYYY',
  'M/D/YY',
  'M-D-YY',
  'D/M/YYYY',
  'D-M-YYYY',
  'D.M.YYYY',
  'D/M/YY',
  'D-M-YY',
  'MMM D YYYY',
  'MMMM D YYYY',
  'D MMM YYYY',
  'D MMMM YYYY',
  'D-MMM-YYYY',
  'D-MMM-YY',
  'ddd MMM D YYYY',
  'dddd MMMM D YYYY',
]

// In strict mode moment's single-letter M/D tokens reject leading zeros, so
// each format is also expanded with its zero-padded MM/DD variants.
const padToken = (format, token) => [
  format,
  format.replace(new RegExp(`(^|[^${token}])${token}(?!${token})`, 'g'), `$1${token}${token}`),
]

const DATE_FORMATS = _.uniq(
  BASE_FORMATS.flatMap(format => padToken(format, 'M')).flatMap(format => padToken(format, 'D')),
)

const TIME_SUFFIX = /(?:T|\s+)\d{1,2}:\d{2}(?::\d{2}(?:\.\d+)?)?\s*(?:[AP]\.?M\.?)?\s*(?:Z|[+-]\d{2}:?\d{2})?$/i

const EXCEL_EPOCH = moment('1899-12-30', 'YYYY-MM-DD')
const EXCEL_SERIAL = /^\d{5}(?:\.\d+)?$/

const normalize = value =>
  String(value)
    .trim()
    .replace(TIME_SUFFIX, '')
    .replace(/(\d)(st|nd|rd|th)\b/gi, '$1')
    .replace(/,/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()

/**
 * Parses the CSV "Date" cell as a local calendar day, regardless of the
 * format the spreadsheet tool saved it in. The time of day, if present, is
 * ignored because entries are placed into free slots of that day.
 * Returns an invalid moment when the value is not recognized.
 */
export const parseCsvDate = value => {
  if (value == null || String(value).trim() === '') return moment.invalid()

  const raw = String(value).trim()
  if (EXCEL_SERIAL.test(raw)) {
    return EXCEL_EPOCH.clone().add(Math.floor(Number(raw)), 'days')
  }

  const parsed = moment(normalize(raw), DATE_FORMATS, true)
  return parsed.isValid() ? parsed.startOf('day') : moment.invalid()
}
